/* eslint-disable eqeqeq */
import { Button, Col, Row, Select, Switch, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaPencilAlt, FaPlus, FaRegTrashAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useApi } from "../../../../../hooks/http2";
import {
  actionMKTProduct,
  searchSelector
} from "../../../../../redux/slices/marketing/product";
import manageWebsiteService from "../../../../../services/manage-website.service";
import { axios, getToken, URL_API } from "../../../../../utils";
import useAsync from "../../../../../utils/useAsync";
import { AlertConfirm, AlertError, AlertSuccess } from "../../../../util/Alert";
import { Panel, PanelBody, PanelHeader } from "../../../../util/panel";

export default function NewsList({ history, match }) {
  const [categoryList, setCategoryList] = useState(["ทั้งหมด"]);
  const [filterCategory, setFilterCategory] = useState("ทั้งหมด");

  const dispatch = useDispatch();
  const search = useSelector(searchSelector);
  const { SET_SEARCH } = actionMKTProduct;

  const list = useApi(
    {
      baseURL: URL_API,
      url: "/manage-website/news/news",
      params: {
        ...search,
        offset: (search.page - 1) * search.limit,
        filter: filterCategory,
      },
      token: true,
    },
    [search, filterCategory]
  );

  const { execute: deleteNewsById } = useAsync(
    manageWebsiteService.deleteNewsById,
    {
      onSuccess: async () => {
        await AlertSuccess("ลบข้อมูลสำเร็จ");
        history.go(0);
      },
      onFailed: () => {
        AlertError();
      },
    }
  );

  const handleChangeStatus = (checked, id) => {
    axios({
      method: "post",
      baseURL: URL_API,
      url: `/manage-website/news/news/${id}/status`,
      headers: { Authorization: "Bearer " + getToken() },
      data: {
        status: checked ? "active" : "inactive",
      },
    })
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  };

  const loadCategory = () => {
    axios({
      method: "get",
      baseURL: URL_API,
      url: "/manage-website/news/category",
    })
      .then((res) => {
        console.log(res);
        let dataCategory = res.data?.data;

        for (let i in dataCategory) {
          setCategoryList((categoryList) => [
            ...categoryList,
            dataCategory[i]?.title,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    loadCategory();
  }, [match.params.id]);

  return (
    <>
      <Panel>
        <PanelHeader>NEWS</PanelHeader>
        <PanelBody>
          <Row type="flex" justify="end" gutter={16} className="mb-4">
            <Col md={6}>
              <Select
                className="w-100"
                allowClear
                value={
                  filterCategory != (null || "")
                    ? filterCategory
                    : categoryList.length > 0
                    ? categoryList[0]
                    : ""
                }
                onChange={(e) => {
                  setFilterCategory(e);
                }}
              >
                {categoryList.map((n) => (
                  <Select.Option key={n}>{n}</Select.Option>
                ))}
              </Select>
            </Col>
            <Col>
              <Button
                type="primary"
                onClick={() => history.push(`${match.path}/add`)}
              >
                <FaPlus className="mr-2" /> เพิ่มข้อมูล
              </Button>
            </Col>
          </Row>
          <Table
            bordered
            size="small"
            loading={list?.loading}
            dataSource={list?.fetch?.data || []}
            rowKey="id"
            pagination={{
              size: "default",
              showLessItems: true,
              showTotal: (total, range) =>
                `${range[0]} - ${range[1]} of ${total}`,
              total: list?.fetch?.total || 0,
              current: search.page,
              pageSize: search.limit,
              onChange: (page) => dispatch(SET_SEARCH({ page: page })),
            }}
          >
            <Table.Column
              title="No."
              key="no"
              align="center"
              dataIndex="row_id"
            />

            <Table.Column
              title="Menu name"
              key="title"
              dataIndex="title"
              align="center"
              render={(text) => text}
            />

            <Table.Column
              title="Category"
              key="content_type"
              dataIndex="content_type"
              align="center"
              render={(text) => text}
            />

            <Table.Column
              title="Public Status"
              key="public_status"
              dataIndex="status"
              align="center"
              render={(text, { id }) => (
                <Switch
                  defaultChecked={text === "active"}
                  onClick={(checked) => handleChangeStatus(checked, id)}
                />
              )}
            />

            <Table.Column
              title="Update Date"
              key="update_date"
              dataIndex="update_date"
              align="center"
              render={(text) =>
                text ? moment(text).format("DD/MM/YYYY HH:mm") : ""
              }
            />
            <Table.Column
              title="Manage"
              key="manage"
              align="center"
              render={(text, { id }) => (
                <Row>
                  <Link to={`${match.path}/${id}`}>
                    <Button type="primary">
                      <FaPencilAlt />
                    </Button>
                  </Link>
                  <Button
                    className="btn-danger ml-1"
                    onClick={async () => {
                      const confirm = await AlertConfirm("ลบข้อมูล");
                      if (confirm) {
                        deleteNewsById(id);
                      }
                    }}
                  >
                    <FaRegTrashAlt />
                  </Button>
                </Row>
              )}
            />
          </Table>
        </PanelBody>
      </Panel>
    </>
  );
}
